import { render } from "./trackDetail.vue?vue&type=template&id=63b0d944&scoped=true&ts=true"
import script from "./trackDetail.vue?vue&type=script&lang=ts"
export * from "./trackDetail.vue?vue&type=script&lang=ts"

import "./trackDetail.vue?vue&type=style&index=0&id=63b0d944&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63b0d944"]])

export default __exports__